"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MicroserviceAuthInterceptor = void 0;
const http_1 = require("@angular/common/http");
const operators_1 = require("rxjs/operators");
const auth_service_1 = require("./auth.service");
/**
 * Auth Interceptor
 *
 * Intercepts all Microservice HTTP requests and appends credentials attribute
 *
 * This allows for session matching between local and the pointed environment
 */
class MicroserviceAuthInterceptor {
    constructor(authService) {
        this.authService = authService;
    }
    intercept(request, next) {
        if (request.url.includes('/rest-services/')) {
            return next.handle(request).pipe(() => 
            // calling the service to get new token for each request
            this.authService.refreshToken().pipe(operators_1.switchMap(() => next.handle(this.addAuthenticationToken(request)))));
        }
        else {
            return next.handle(request);
        }
    }
    addAuthenticationToken(request) {
        const accessToken = this.authService.getToken();
        // If access token is null or undefined we will return the original request
        if (!accessToken) {
            return request;
        }
        // We have cloned the request as the original one is immutable
        return request.clone({
            withCredentials: true,
            setHeaders: {
                Authorization: this.authService.getToken(),
                'Client': 'WEB',
                'CS-SESSION-ID': this.authService.getSession()
            }
        });
    }
}
exports.MicroserviceAuthInterceptor = MicroserviceAuthInterceptor;
//# sourceMappingURL=auth.interceptor.js.map